module.exports = __webpack_public_path__ + "assets/img/ps-2-light.660cc86e.png";